/**
 * view_pending-withdrawals.js
 */
import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
import viewConfirmationmessage from '../../commonview/lib/view-confirmationmessage.js';
import viewNotification from '../../commonview/lib/view-notification.js';
import viewBinaryquestion from '../../commonview/lib/view-binaryquestion.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';
import { fetchJson } from './../../../core/ajax-json.js';
import currencyFormatter from './../../../libs/currency-formatter.js';
import { getLocale } from './../../../libs/locale.js';


let textkeysObj = {};
let elements = {
	assembled: false
};
const selectors = {};
const nodetree = core.nodetree;
const create = core.create;

function createSvgIcon() {
	return create({
		type: 'svg',
		viewBox: '0 0 24 24',
		class: 'notify__svg-icon u-dib'
	});
}

function createPathForIcon() {
	return create({
		type: 'path',
		d: 'M17.625,10.4698337 C14.6364661,10.4781294 12.2205035,12.9075358 12.2287915,15.8960698 C12.2370796,18.8846037 14.6664798,21.3005725 17.6550137,21.2922921 C20.6435477,21.2840117 23.0595227,18.8546177 23.05125,15.8660837 C23.0472773,14.4309293 22.4733515,13.0561338 21.455731,12.0441395 C20.4381106,11.0321451 19.0601544,10.46585 17.625,10.4698337 L17.625,10.4698337 Z M17.625,20.5423337 C15.0545867,20.5340487 12.9760152,18.446525 12.9787769,15.8760999 C12.9815386,13.3056748 15.064591,11.2226223 17.6350161,11.2198606 C20.2054413,11.217099 22.292965,13.2956705 22.30125,15.8660837 C22.3052515,17.1075247 21.8138616,18.2992735 20.9360257,19.1771094 C20.0581898,20.0549453 18.866441,20.5463352 17.625,20.5423337 Z M16.44,22.2410837 C16.3357285,22.0499305 16.0999132,21.9740739 15.90375,22.0685837 C15.1346762,22.4189089 14.3282397,22.6805919 13.5,22.8485837 C11.3289858,23.2826695 9.0935142,23.2826695 6.9225,22.8485837 C5.95970531,22.6586873 5.02734516,22.338228 4.15125,21.8960837 C3.48523404,21.5802166 2.88670982,21.1383274 2.38875,20.5948337 C2.00583983,20.1874314 1.78568281,19.6537174 1.77,19.0948337 L1.77,16.6160837 C2.02399186,16.9170384 2.31076539,17.1887186 2.625,17.4260837 C2.9782739,17.6897617 3.35482931,17.9207157 3.75,18.1160837 C4.68682121,18.5885097 5.68341162,18.9316396 6.7125,19.1360837 C7.85735095,19.3721519 9.02357129,19.4890253 10.1925,19.4848337 C10.6325,19.4848337 11.06625,19.4685837 11.49375,19.4360837 C11.7161518,19.4200739 11.8837777,19.2273041 11.86875,19.0048337 C11.8527401,18.7824319 11.6599703,18.614806 11.4375,18.6298337 C11.035,18.6598337 10.62375,18.6748337 10.20375,18.6748337 C9.09920056,18.6794064 7.99712315,18.5700783 6.915,18.3485837 C5.94539997,18.1579554 5.00661069,17.8349311 4.125,17.3885837 C3.45898404,17.0727166 2.86045982,16.6308274 2.3625,16.0873337 C1.97958983,15.6799314 1.75943281,15.1462174 1.74375,14.5873337 C1.76685624,13.9823219 2.01884023,13.4086562 2.44875,12.9823337 C3.00790056,12.3996431 3.68047072,11.9376499 4.425,11.6248337 C4.52539771,11.5842186 4.60333341,11.502181 4.63875,11.3998337 C4.68001369,11.2988878 4.68001369,11.1857797 4.63875,11.0848337 C4.59095793,10.992151 4.51093753,10.9201326 4.41375,10.8823337 C4.31384035,10.8360958 4.19865965,10.8360958 4.09875,10.8823337 C3.65163376,11.0949227 3.22378296,11.3458616 2.82,11.6323337 C2.47063612,11.8783239 2.15320271,12.1667852 1.875,12.4910837 C1.59777499,12.7822738 1.36979427,13.1166455 1.2,13.4810837 C1.05207203,13.8097224 0.968076086,14.1635234 0.9525,14.5235837 L0.9525,19.0873337 C0.970963861,19.7985819 1.23609454,20.4812934 1.7025,21.0185837 C2.261039,21.6933025 2.95969954,22.2384113 3.75,22.6160837 C4.68682121,23.0885097 5.68341162,23.4316396 6.7125,23.6360837 C9.00807386,24.0997201 11.3731761,24.0997201 13.66875,23.6360837 C14.5589429,23.4562827 15.4257737,23.1757265 16.2525,22.7998337 C16.4530376,22.7021773 16.5368648,22.4607549 16.44,22.2598337 L16.44,22.2410837 Z M9.91875,13.9235837 C9.9605304,13.9664304 10.0101888,14.0008093 10.065,14.0248337 C10.1573077,14.0698337 10.2651923,14.0698337 10.3575,14.0248337 C10.4123112,14.0008093 10.4619696,13.9664304 10.50375,13.9235837 L15.70875,8.71858374 C15.860195,8.56166452 15.860195,8.31300296 15.70875,8.15608374 C15.6414752,8.06932305 15.5372732,8.01930606 15.4275,8.02108374 C15.3119934,8.02239828 15.2021271,8.07122773 15.12375,8.15608374 L10.62375,12.6560837 L10.62375,2.90608374 C10.6278628,2.79506662 10.58254,2.68794008 10.5,2.61358374 C10.3430808,2.46213875 10.0944192,2.46213875 9.9375,2.61358374 C9.85496001,2.68794008 9.80963724,2.79506662 9.81375,2.90608374 L9.81375,12.6560837 L5.31375,8.15608374 C5.2353729,8.07122773 5.12550664,8.02239828 5.01,8.02108374 C4.90022682,8.01930606 4.79602476,8.06932305 4.72875,8.15608374 C4.57730502,8.31300296 4.57730502,8.56166452 4.72875,8.71858374 L9.91875,13.9235837 Z M20.17875,16.5973337 C20.574324,16.5973337 20.895,16.2766577 20.895,15.8810837 C20.895,15.4855098 20.574324,15.1648337 20.17875,15.1648337 C19.783176,15.1648337 19.4625,15.4855098 19.4625,15.8810837 C19.4625,16.2766577 19.783176,16.5973337 20.17875,16.5973337 Z M17.64,16.5973337 C18.035574,16.5973337 18.35625,16.2766577 18.35625,15.8810837 C18.35625,15.4855098 18.035574,15.1648337 17.64,15.1648337 C17.244426,15.1648337 16.92375,15.4855098 16.92375,15.8810837 C16.92375,16.2766577 17.244426,16.5973337 17.64,16.5973337 Z M15.0975,16.5973337 C15.493074,16.5973337 15.81375,16.2766577 15.81375,15.8810837 C15.81375,15.4855098 15.493074,15.1648337 15.0975,15.1648337 C14.701926,15.1648337 14.38125,15.4855098 14.38125,15.8810837 C14.38125,16.2766577 14.701926,16.5973337 15.0975,16.5973337 Z' // eslint-disable-line max-len
	});
}

function createDiv(classname) {
	return create({
		type: 'div',
		class: classname
	});
}

function createMainTitle(txt) {
	const elm = create({
		type: 'h2',
		class: 'notify__main-title'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createSupportTitle(txt) {
	const elm = create({
		type: 'p',
		class: 'notify__p'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createPendingWithdrawal(p) {
	const paymentMethod = p.descr;
	const withdrawAmount = p.amount;
	const transactionDate = p.date;
	const withdrawId = p.withdrawId;
	const pendingWithdrawalWrapper = create({
		type: 'div',
		class: 'js-withdraw-event-filter pending-withdrawal u-mb2 u-pb1',
		withdrawid: withdrawId
	});
	const wrapDateIconSpinner = createDiv('pending-withdrawal__row');
	const wrapMethodAmount = createDiv('pending-withdrawal__row');
	const wrapIconSpinner = create({
		type: 'a',
		href: '#',
		class: 'js-cancel-withdraw-btn pending-withdrawal__action u-relative'
	});
	const date = create({
		type: 'small',
		class: 'pending-withdrawal__date'
	});
	const method = createDiv('pending-withdrawal__method');
	const svgIcon = create({
		type: 'svg',
		viewBox: '0 0 24 24',
		class: 'pending-withdrawal__cancel-icon'
	});
	const path = create({
		type: 'path',
		d: 'M12.5,21.772 C11.260608,21.7787885 10.0330797,21.5304372 8.8938,21.0424 C4.82651877,19.3248259 2.53256526,14.9793985 3.40878116,10.6521496 C4.28499707,6.3249007 8.08873066,3.21418162 12.5038,3.21418162 C16.9188693,3.21418162 20.7226029,6.3249007 21.5988188,10.6521496 C22.4750347,14.9793985 20.1810812,19.3248259 16.1138,21.0424 C14.9721701,21.5314607 13.7419492,21.7798334 12.5,21.772 L12.5,21.772 Z M12.5,4.026 C11.3703174,4.01984926 10.2514516,4.24620939 9.213,4.691 C6.06950445,6.01349438 4.02510973,9.09153995 4.02510973,12.5019 C4.02510973,15.91226 6.06950445,18.9903056 9.213,20.3128 C11.3158939,21.1997941 13.6879061,21.1997941 15.7908,20.3128 C18.9342955,18.9903056 20.9786903,15.91226 20.9786903,12.5019 C20.9786903,9.09153995 18.9342955,6.01349438 15.7908,4.691 C14.7511732,4.24569798 13.6309612,4.01932719 12.5,4.026 L12.5,4.026 Z M17.1284,17.155 C17.28387,16.9968038 17.28387,16.7431962 17.1284,16.585 L13.0472,12.5 L17.1246,8.4188 C17.28007,8.26060383 17.28007,8.00699617 17.1246,7.8488 C16.9664038,7.69333002 16.7127962,7.69333002 16.5546,7.8488 L12.4772,11.93 L8.396,7.8526 C8.23780383,7.69713002 7.98419617,7.69713002 7.826,7.8526 C7.67053002,8.01079617 7.67053002,8.26440383 7.826,8.4226 L11.9072,12.5 L7.8298,16.5812 C7.67433002,16.7393962 7.67433002,16.9930038 7.8298,17.1512 C7.98799617,17.30667 8.24160383,17.30667 8.3998,17.1512 L12.4772,13.07 L16.5584,17.1474 C16.714515,17.3049985 16.9681386,17.3083802 17.1284,17.155 L17.1284,17.155 Z' // eslint-disable-line max-len
	});
	const amount = create({
		type: 'span',
		class: 'pending-withdrawal__amount'
	});
	const cancelBtn = create({
		type: 'btn',
		class: 'js-cancel-withdraw-btn'
	});
	method.innerHTML = paymentMethod;
	amount.innerHTML = withdrawAmount;
	date.innerHTML = transactionDate;
	cancelBtn.innerHTML = (textkeysObj['cancel-link'] || 'cancel-link-textkey');

	svgIcon.appendChild(path);
	// wrapIconSpinner.appendChild(date);
	wrapDateIconSpinner.appendChild(date);
	wrapIconSpinner.appendChild(svgIcon);
	wrapMethodAmount.appendChild(method);
	wrapMethodAmount.appendChild(amount);
	wrapDateIconSpinner.appendChild(wrapIconSpinner);
	pendingWithdrawalWrapper.appendChild(wrapDateIconSpinner);
	pendingWithdrawalWrapper.appendChild(wrapMethodAmount);
	return pendingWithdrawalWrapper;
}

function clickCancelWithdrawHandler(e) {
	function cancelHandler(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		const withdrawId = p.elm.getAttribute('withdrawid');
		const offerTextkey = (textkeysObj['confirmation-message-pending-withdraw'] || 'confirmation-message-pending-withdraw-textkey-missing');
		const acceptTextkey = (textkeysObj['confirmation-message-pending-withdraw-yes'] || 'confirmation-message-pending-withdraw-yes-textkey-missing');
		const denyTextkey = (textkeysObj['confirmation-message-pending-withdraw-no'] || 'confirmation-message-pending-withdraw-no-textkey-missing');

		function ifUserConfirm() {
			actions.viewPendingWithdrawals(withdrawId);
		}
		viewBinaryquestion.show(offerTextkey, acceptTextkey, denyTextkey, ifUserConfirm);
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked*/
	core.handle(e, '.js-withdraw-event-filter', cancelHandler, true);
}

function addListeners() {
	core.addListener(elements.wrap, 'click', clickCancelWithdrawHandler);
}

function removeListeners() {
	/* the core.removeListener-method allows the method to be used also if the elements.wrap is not there or the handler which prevents errors thrown. */
	if (elements && elements.wrap) {
		core.removeListener(elements.wrap, 'click', clickCancelWithdrawHandler);
	}
}

function getSupportTitle() {
	if (elements.origin) {
		if (elements.origin === 'account') {
			return (elements.supportTitle || createSupportTitle(textkeysObj['deposit-pendingwithdrawals-support-title-account']));
		} else if (elements.origin === 'deposit') {
			return (elements.supportTitle || createSupportTitle(textkeysObj['deposit-pendingwithdrawals-support-title-deposit']));
		} else if (elements.origin === 'withdraw') {
			return (elements.supportTitle || createSupportTitle(textkeysObj['deposit-pendingwithdrawals-support-title-withdraw']));
		}
	}
	return (elements.supportTitle || createSupportTitle(textkeysObj['deposit-pendingwithdrawals-support-title-account']));
}
function assembleStaticElements() {
	elements.staticWrap = createDiv('payment__content-wrapper');
	elements.dynamicWrap = createDiv('pendingwithrawals__wrapdynamic');
	elements.svg = (elements.svg || createSvgIcon());
	elements.path = (elements.path || createPathForIcon());
	elements.staticWrapSub = createDiv('notify__head u-pl2 u-pr2 u-text-c');
	elements.staticWrapIcon = createDiv('notify__icon-wrapper u-text-c');
	elements.mainTitle = (elements.mainTitle || createMainTitle(textkeysObj['deposit-pendingwithdrawals-title']));
	elements.supportTitle = getSupportTitle();
	elements.svg.appendChild(elements.path);
	elements.staticWrapIcon.appendChild(elements.svg);
	elements.staticWrapSub.appendChild(elements.staticWrapIcon);
	elements.staticWrapSub.appendChild(elements.mainTitle);
	elements.staticWrapSub.appendChild(elements.supportTitle);
	elements.staticWrap.appendChild(elements.staticWrapSub);
	elements.wrap.appendChild(elements.staticWrap);
	elements.staticWrap.appendChild(elements.dynamicWrap);
	elements.assembledStatic = true;
}

function assembleDynamicElements(withrawalsObj) {
	let pendingWithdrawalElements = [];
	let isAlreadyDisplayed;
	let wObjKey;
	let descr;
	let amount;
	let date;
	let withdrawId;
	let hasWithdrawFormat;

	fetchJson('/player/currency')
		.then((response) => {
			if (withrawalsObj) {
				elements.pendingwithdrawals_byid = (elements.pendingwithdrawals_byid || {});
				Object.keys(withrawalsObj).forEach((key) => {
					isAlreadyDisplayed = Boolean(elements.pendingwithdrawals_byid[key]);
					wObjKey = withrawalsObj[key];
					date = (wObjKey && wObjKey.time);
					descr = (wObjKey && wObjKey.paymentMethodDescr);
					withdrawId = ((wObjKey && wObjKey.id && wObjKey.id !== 'undefined') ? wObjKey.id : null);
					const formattedAmount = currencyFormatter.format(wObjKey && wObjKey.amount, response.result, getLocale());
					amount = formattedAmount;
					hasWithdrawFormat = Boolean(amount && date && descr && withdrawId);
					/* a withdrawId of 0 or the string version of undefined are not accepted
					 replace string versions of undefined in the module that created the state-object instead */
					if (isAlreadyDisplayed) {
						/* remove inactive and already displayed withdrawal */
						elements.pendingwithdrawals_byid[key] = core.deleteElement(elements.pendingwithdrawals_byid[key], 'view_pending_withdrawals:removeInactiveWithdrawals');
					} else if (hasWithdrawFormat) {
						const temp = createPendingWithdrawal({
							amount,
							date,
							descr,
							withdrawId
						});
						pendingWithdrawalElements.push(temp);
						/* store a reference to the withdrawal */
						elements.pendingwithdrawals_byid[key] = temp;
					}
				});

				pendingWithdrawalElements = nodetree(pendingWithdrawalElements);
				elements.dynamicWrap.appendChild(pendingWithdrawalElements);
				elements.assembledDynamic = true;
			}
		});
}

function markWithWarnClass(id) {
	const isDisplayed = ((id && elements) && (elements.pendingwithdrawals_byid && elements.pendingwithdrawals_byid[id]));
	if (isDisplayed) {
		core.addClass(elements.pendingwithdrawals_byid[id], 'failed_to_execute');
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	elements = core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view_pending_withdrawals:271');
}

export default {
	init(p) {
		/* clean the area if necessary after skipping back and forth in the depositflow */
		deleteAllElements();
		elements = core.selectElements(selectors, 'pendingwithdrawals:view_pending_withdrawals:265');
		/* add the wrapping element to elements-object */
		elements.wrap = core.getElementIfValid(p, 'wrap', 'view_pending_withdrawals:267');
		elements.origin = p.origin;
		textkeysObj = viewTextkeys.depositflow();
		assembleStaticElements();
		addListeners();
	},
	update(state) {
		const statePendingById = ((state && state.pending_withdrawals) && state.pending_withdrawals.by_id);
		const failure = ((state && state.fetch_cancel_withdraw) && state.fetch_cancel_withdraw.failure);
		const errMsg = ((state && state.fetch_cancel_withdraw) && state.fetch_cancel_withdraw.error);
		let failTitle;
		let failText;
		let failBtn;

		let withdrawId = null;
		if (state && (state.pending_withdrawals)) {
			if (state.pending_withdrawals.empty) {
				deleteAllElements();
				elements.mainTitle = createMainTitle(textkeysObj['deposit-pendingwithdrawals-empty-title']);
				elements.supportTitle = createSupportTitle(textkeysObj['deposit-pendingwithdrawals-empty-support-title']);
				assembleStaticElements();
			}

			if (elements.assembledStatic) {
				/* if a pending withdrawal shall be removed from the current list, the state is updated from 'pending_withdrawals'-module and not 'fetch_cancel_withdraw'
				because the 'pending_withdrawals'-module shall maintain the complete current state of the list of pending withdrawals.
				*/
				assembleDynamicElements(statePendingById);
			} else {
				assembleStaticElements();
				assembleDynamicElements(statePendingById);
			}
		}

		if (state && state.fetch_cancel_withdraw) {
			withdrawId = state.fetch_cancel_withdraw.withdrawId;
			if (errMsg) {
				/* display the red alert message dropping down vertically from top*/
				viewNotification.show({
					titleTxt: null,
					mainTxt: `connection error pending withdrawal:${withdrawId}`
				});
			} else if (failure) {
				failTitle = (textkeysObj['deposit-pendingwithdrawals-fail-feedbacktitle'] || 'cancel failed');
				failText = (textkeysObj['deposit-pendingwithdrawals-fail-feebacktxt'] || 'cancel pending withdrawal was not possible, try again later or call support');
				failBtn = (textkeysObj['deposit-pendingwithdrawals-fail-btn'] || 'ok');
				markWithWarnClass(withdrawId);
				viewConfirmationmessage.show('default-failure', failTitle, failText, failBtn);
			}
		}
	},
	close() {
		removeListeners();
		deleteAllElements();
		/* these have to be closed or they may remain if a new url is entered*/
		viewConfirmationmessage.close();
		viewNotification.close();
		viewBinaryquestion.close();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/pendingwithdrawals/lib/view-pending-withdrawals.js